import { createClient, SupabaseClient } from '@supabase/supabase-js'
import type { Database } from '../../supabase/types'
import { configService } from './config'

// Global Supabase client instance
let supabaseClient: SupabaseClient<Database> | null = null;

/**
 * 初始化 Supabase 客户端
 * Initialize Supabase client
 */
export async function initializeSupabase(): Promise<SupabaseClient<Database>> {
  if (supabaseClient) {
    return supabaseClient;
  }

  try {
    // 确保配置服务已初始化
    await configService.initialize();
    
    // 获取安全配置
    const { url, anonKey } = configService.getSupabaseConfig();

    // 创建 Supabase 客户端
    supabaseClient = createClient<Database>(url, anonKey, {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true
      },
      realtime: {
        params: {
          eventsPerSecond: 10
        }
      }
    });

    return supabaseClient;
  } catch (error) {
    console.error('Failed to initialize Supabase client:', error);
    throw new Error('Supabase initialization failed. Please check your configuration.');
  }
}

/**
 * 获取 Supabase 客户端
 * Get Supabase client
 */
export function getSupabaseClient(): SupabaseClient<Database> {
  if (!supabaseClient) {
    throw new Error('Supabase client not initialized. Call initializeSupabase() first.');
  }
  return supabaseClient;
}

/**
 * 向后兼容的导出
 * Backward compatible export
 * 
 * 注意：这将在运行时抛出错误，提醒开发者使用新的初始化方法
 * Note: This will throw at runtime, reminding developers to use the new initialization method
 */
export const supabase = new Proxy({} as SupabaseClient<Database>, {
  get() {
    throw new Error(
      'Direct supabase client access is deprecated for security reasons. ' +
      'Please use initializeSupabase() or getSupabaseClient() instead.'
    );
  }
});